<template>
  <div class="pa-4 pa-md-5">
    <v-col cols="12" class="pa-0">
      <!-- Row 1: Indicador Costo por Kilómetro / Hora -->
      <v-row class="mb-2">
        <v-col cols="12">
          <v-card
            class="dashboard-card card-top-border rounded-lg elevation-2 overflow-hidden"
          >
            <v-card-title
              class="dashboard-card-title py-3 px-4 d-flex align-center justify-space-between flex-wrap"
            >
              <div class="d-flex align-center flex-wrap">
                <v-icon color="secondary" class="mr-2"
                  >mdi-calculator-variant-outline</v-icon
                >
                <span class="text-h6 font-weight-bold text--primary">
                  Indicador Costo por Kilómetro / Hora &bull; {{ annio }}
                </span>
                <v-chip
                  v-if="mesSeleccionadoCosto !== null"
                  color="primary"
                  small
                  class="font-weight-bold ml-3 elevation-1"
                  close
                  @click:close="mesSeleccionadoCosto = null"
                >
                  <v-icon left x-small>mdi-calendar-month</v-icon>
                  Mes: {{ meses[parseInt(mesSeleccionadoCosto) - 1] }}
                </v-chip>
              </div>
            </v-card-title>
            <v-card-subtitle
              class="dashboard-card-subtitle px-4 pt-1 pb-2 d-flex align-center"
            >
              <v-icon x-small color="grey" class="mr-1"
                >mdi-information-outline</v-icon
              >
              <span
                >No se consideran neumáticos en SCRAP &bull; Evaluación de costo
                unitario por rendimiento operativo</span
              >
            </v-card-subtitle>
            <v-card-text class="px-4 py-2">
              <v-row justify="center" class="pa-0 mb-3">
                <div
                  class="kpi-formula-container pa-3 rounded-lg w-100 overflow-hidden"
                >
                  <div
                    class="d-flex align-center justify-center text-caption flex-nowrap overflow-x-auto"
                  >
                    <!-- Título / etiqueta de indicador -->
                    <div
                      class="text-center font-weight-bold grey--text text--darken-3 text-caption px-3 py-1 bg-white rounded-lg elevation-1 border-subtle"
                      style="line-height: 1.2"
                    >
                      Costo por<br />{{
                        unidadMedidaTexto.label.includes("hr")
                          ? "Hora"
                          : "Kilómetro"
                      }}
                    </div>

                    <span
                      class="mx-2 font-weight-bold text-grey-darken-2 text-h6"
                      >=</span
                    >

                    <!-- Fracción conceptual -->
                    <div
                      class="d-inline-flex flex-column align-center px-3 py-1 bg-white rounded-lg elevation-1 border-subtle"
                    >
                      <span
                        class="pb-1 border-bottom-fraction px-2 font-weight-medium text-caption text--secondary"
                      >
                        Precio de neumáticos (USD)
                      </span>
                      <span
                        class="pt-1 px-2 font-weight-medium text-caption text--secondary"
                      >
                        Rendimiento de neumáticos {{ unidadMedidaTexto.label }}
                      </span>
                    </div>

                    <template
                      v-if="
                        datosKpiCosto &&
                        (datosKpiCosto.precio !== undefined ||
                          datosKpiCosto.costo !== undefined)
                      "
                    >
                      <span
                        class="mx-2 font-weight-bold text-grey-darken-2 text-h6"
                        >=</span
                      >

                      <!-- Fracción de valores -->
                      <div
                        class="d-inline-flex flex-column align-center px-3 py-1 bg-white rounded-lg elevation-1 border-subtle"
                      >
                        <span
                          class="pb-1 border-bottom-fraction px-2 font-weight-bold primary--text text-subtitle-2 font-mono"
                        >
                          $
                          {{
                            Number(datosKpiCosto.precio || 0).toLocaleString(
                              "es-PE",
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              },
                            )
                          }}
                        </span>
                        <span
                          class="pt-1 px-2 font-weight-bold text--primary text-subtitle-2 font-mono"
                        >
                          {{
                            Number(
                              datosKpiCosto.rendimiento || 0,
                            ).toLocaleString("es-PE", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          }}
                          {{ unidadMedidaTexto.label }}
                        </span>
                      </div>

                      <template
                        v-if="
                          datosKpiCosto.costo !== undefined &&
                          datosKpiCosto.costo !== ''
                        "
                      >
                        <span
                          class="mx-2 font-weight-bold text-grey-darken-2 text-h6"
                          >=</span
                        >

                        <!-- Resultado -->
                        <div
                          class="kpi-result-chip px-3 py-1 rounded-lg elevation-1 font-mono"
                        >
                          <span
                            class="text-caption font-weight-bold d-block"
                            style="font-size: 0.68rem !important"
                          >
                            Costo Calculado
                          </span>
                          <span class="text-subtitle-1 font-weight-black">
                            $ {{ Number(datosKpiCosto.costo || 0).toFixed(4) }}
                          </span>
                          <span
                            class="text-caption ml-1 font-weight-bold opacity-80"
                          >
                            {{ unidadMedidaTexto.result }}
                          </span>
                        </div>
                      </template>
                    </template>
                  </div>
                </div>
              </v-row>

              <IndicadorCosto
                :CostoPorKilometro="CostoPorKilometro"
                :MesesCostoPorKilometro="MesesCostoPorKilometro"
                :SelectedMes="mesSeleccionadoCosto"
                :SelectedCelda="celdaSeleccionadaCosto"
                @seleccionar-mes="mesSeleccionadoCosto = $event"
                @seleccionar-celda="celdaSeleccionadaCosto = $event"
              />
            </v-card-text>
            <v-card-actions class="dashboard-card-actions px-4 py-3">
              <v-row dense class="w-100 ma-0">
                <v-col cols="12" sm="6" class="pa-1">
                  <v-btn
                    @click="verDetalles()"
                    :loading="loadingVerDetalle"
                    outlined
                    color="secondary"
                    small
                    block
                    class="rounded-lg text-none font-weight-bold action-dashboard-btn"
                  >
                    <v-icon left small>mdi-chart-timeline-variant</v-icon>
                    Ver Detalles
                  </v-btn>
                </v-col>
                <v-col cols="12" sm="6" class="pa-1">
                  <v-btn
                    @click="exportarExcelCostoxKilometro()"
                    color="success"
                    dark
                    :loading="loadingButtonCosto"
                    small
                    block
                    class="rounded-lg text-none font-weight-bold elevation-1 action-dashboard-btn"
                  >
                    <v-icon left small>mdi-file-excel-box</v-icon>
                    Exportar Excel
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <!-- Row 2: Reencauche & Reencauchabilidad -->
      <v-row class="mb-2">
        <v-col cols="12" lg="6" id="sec-reencauche">
          <v-card
            class="dashboard-card card-top-border rounded-lg elevation-2 overflow-hidden h-100 d-flex flex-column"
          >
            <v-card-title
              class="dashboard-card-title py-3 px-4 d-flex align-center justify-space-between flex-wrap"
            >
              <div class="d-flex align-center flex-wrap">
                <v-icon color="secondary" class="mr-2"
                  >mdi-recycle-variant</v-icon
                >
                <span class="text-h6 font-weight-bold text--primary">
                  Índice de Reencauche &bull; {{ annio }}
                </span>
                <v-chip
                  v-if="mesSeleccionadoReencauche !== null"
                  color="primary"
                  small
                  class="font-weight-bold ml-2 elevation-1"
                  close
                  @click:close="seleccionarMesReencauche(null)"
                >
                  <v-icon left x-small>mdi-calendar-month</v-icon>
                  Mes: {{ meses[mesSeleccionadoReencauche] }}
                </v-chip>
              </div>
            </v-card-title>
            <v-card-subtitle
              class="dashboard-card-subtitle px-4 pt-1 pb-2 d-flex align-center"
            >
              <v-icon x-small color="grey" class="mr-1"
                >mdi-information-outline</v-icon
              >
              <span
                >Proporción de neumáticos reencauchados sobre el total
                activo</span
              >
            </v-card-subtitle>
            <v-card-text class="px-4 py-2 flex-grow-1">
              <v-row justify="center" class="pa-0 mb-3">
                <div
                  class="kpi-formula-container pa-3 rounded-lg w-100 overflow-hidden"
                >
                  <div
                    class="d-flex align-center justify-center text-caption flex-nowrap overflow-x-auto"
                  >
                    <div
                      class="d-inline-flex flex-column align-center px-3 py-1 bg-white rounded-lg elevation-1 border-subtle"
                    >
                      <span
                        class="pb-1 border-bottom-fraction px-2 font-weight-medium text-caption text--secondary"
                      >
                        Total neumáticos reencauchados
                      </span>
                      <span
                        class="pt-1 px-2 font-weight-medium text-caption text--secondary"
                      >
                        Total neumáticos
                      </span>
                    </div>

                    <template
                      v-if="
                        datosKpiReencauche &&
                        (datosKpiReencauche.total_reencauchados !== undefined ||
                          datosKpiReencauche.indice_reencauche !== undefined)
                      "
                    >
                      <span
                        class="mx-2 font-weight-bold text-grey-darken-2 text-h6"
                        >=</span
                      >

                      <div
                        class="d-inline-flex flex-column align-center px-3 py-1 bg-white rounded-lg elevation-1 border-subtle"
                      >
                        <span
                          class="pb-1 border-bottom-fraction px-2 font-weight-bold info--text text-subtitle-2 font-mono"
                        >
                          {{
                            Number(
                              datosKpiReencauche.total_reencauchados || 0,
                            ).toLocaleString("es-PE")
                          }}
                        </span>
                        <span
                          class="pt-1 px-2 font-weight-bold text--primary text-subtitle-2 font-mono"
                        >
                          {{
                            Number(
                              datosKpiReencauche.total_neumaticos || 0,
                            ).toLocaleString("es-PE")
                          }}
                        </span>
                      </div>

                      <template
                        v-if="
                          datosKpiReencauche.indice_reencauche !== undefined &&
                          datosKpiReencauche.indice_reencauche !== ''
                        "
                      >
                        <span
                          class="mx-2 font-weight-bold text-grey-darken-2 text-h6"
                          >=</span
                        >

                        <div
                          class="kpi-result-chip px-3 py-1 rounded-lg elevation-1 font-mono"
                        >
                          <span
                            class="text-caption font-weight-bold d-block"
                            style="font-size: 0.68rem !important"
                          >
                            Índice
                          </span>
                          <span class="text-subtitle-1 font-weight-black">
                            {{
                              (
                                datosKpiReencauche.indice_reencauche * 100
                              ).toFixed(2)
                            }}%
                          </span>
                        </div>
                      </template>
                    </template>
                  </div>
                </div>
              </v-row>

              <GraficoBar
                Title="Índice de reencauche"
                Labelsdataset="Índice de reencauche(%)"
                Labelscale_x="Meses"
                Labelscale_y="Porcentaje de reencauche (%)"
                IdGrafico="graficoreencauche"
                :Labels="Labels"
                :DatosGrafico="datosGraficoReencauche"
                :SelectedIndex="mesSeleccionadoReencauche"
                @click-bar="seleccionarMesReencauche"
                v-if="mostrarGraficoReencauche == true"
              ></GraficoBar>
            </v-card-text>
            <v-card-actions class="dashboard-card-actions px-4 py-3">
              <v-row dense class="w-100 ma-0">
                <v-col cols="12" sm="6" class="pa-1">
                  <v-btn
                    @click="ver('reencauche')"
                    outlined
                    color="secondary"
                    small
                    block
                    class="rounded-lg text-none font-weight-bold action-dashboard-btn"
                  >
                    <v-icon left small>mdi-open-in-new</v-icon>
                    Ver Más
                  </v-btn>
                </v-col>
                <v-col cols="12" sm="6" class="pa-1">
                  <v-btn
                    @click="exportarExcelIndiceReencauche()"
                    :loading="loadingButtonReencauche"
                    color="success"
                    dark
                    small
                    block
                    class="rounded-lg text-none font-weight-bold elevation-1 action-dashboard-btn"
                  >
                    <v-icon left small>mdi-file-excel-box</v-icon>
                    Exportar Excel
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>

        <v-col cols="12" lg="6" id="sec-reencauchabilidad">
          <v-card
            class="dashboard-card card-top-border rounded-lg elevation-2 overflow-hidden h-100 d-flex flex-column"
          >
            <v-card-title
              class="dashboard-card-title py-3 px-4 d-flex align-center justify-space-between flex-wrap"
            >
              <div class="d-flex align-center flex-wrap">
                <v-icon color="secondary" class="mr-2">mdi-cached</v-icon>
                <span class="text-h6 font-weight-bold text--primary">
                  Índice de Reencauchabilidad &bull; {{ annio }}
                </span>
                <v-chip
                  v-if="mesSeleccionadoReencauchabilidad !== null"
                  color="primary"
                  small
                  class="font-weight-bold ml-2 elevation-1"
                  close
                  @click:close="seleccionarMesReencauchabilidad(null)"
                >
                  <v-icon left x-small>mdi-calendar-month</v-icon>
                  Mes: {{ meses[mesSeleccionadoReencauchabilidad] }}
                </v-chip>
              </div>
            </v-card-title>
            <v-card-subtitle
              class="dashboard-card-subtitle px-4 pt-1 pb-2 d-flex align-center"
            >
              <v-icon x-small color="grey" class="mr-1"
                >mdi-information-outline</v-icon
              >
              <span
                >Promedio de ciclos y vidas de reencauche logrados por
                carcasa</span
              >
            </v-card-subtitle>
            <v-card-text class="px-4 py-2 flex-grow-1">
              <v-row justify="center" class="pa-0 mb-3">
                <div
                  class="kpi-formula-container pa-3 rounded-lg w-100 overflow-hidden"
                >
                  <div
                    class="d-flex align-center justify-center text-caption flex-nowrap overflow-x-auto"
                  >
                    <div
                      class="d-inline-flex flex-column align-center px-3 py-1 bg-white rounded-lg elevation-1 border-subtle"
                    >
                      <span
                        class="pb-1 border-bottom-fraction px-2 font-weight-medium text-caption text--secondary"
                      >
                        Número de veces reencauche
                      </span>
                      <span
                        class="pt-1 px-2 font-weight-medium text-caption text--secondary"
                      >
                        Total carcasas reencauchadas
                      </span>
                    </div>

                    <template
                      v-if="
                        datosKpiReencauchabilidad &&
                        (datosKpiReencauchabilidad.numero_veces_reencauche !==
                          undefined ||
                          datosKpiReencauchabilidad.total_reencauchados !==
                            undefined ||
                          datosKpiReencauchabilidad.indice_reencauchabilidad !==
                            undefined)
                      "
                    >
                      <span
                        class="mx-2 font-weight-bold text-grey-darken-2 text-h6"
                        >=</span
                      >

                      <div
                        class="d-inline-flex flex-column align-center px-3 py-1 bg-white rounded-lg elevation-1 border-subtle"
                      >
                        <span
                          class="pb-1 border-bottom-fraction px-2 font-weight-bold primary--text text-subtitle-2 font-mono"
                        >
                          {{
                            Number(
                              datosKpiReencauchabilidad.numero_veces_reencauche ??
                                datosKpiReencauchabilidad.total_reencauchados ??
                                0,
                            ).toLocaleString("es-PE")
                          }}
                        </span>
                        <span
                          class="pt-1 px-2 font-weight-bold text--primary text-subtitle-2 font-mono"
                        >
                          {{
                            Number(
                              datosKpiReencauchabilidad.total_carcasas_reencauchadas ??
                                datosKpiReencauchabilidad.total_neumaticos ??
                                0,
                            ).toLocaleString("es-PE")
                          }}
                        </span>
                      </div>

                      <template
                        v-if="
                          datosKpiReencauchabilidad.indice_reencauchabilidad !==
                            undefined &&
                          datosKpiReencauchabilidad.indice_reencauchabilidad !==
                            ''
                        "
                      >
                        <span
                          class="mx-2 font-weight-bold text-grey-darken-2 text-h6"
                          >=</span
                        >

                        <div
                          class="kpi-result-chip px-3 py-1 rounded-lg elevation-1 font-mono"
                        >
                          <span
                            class="text-caption font-weight-bold d-block"
                            style="font-size: 0.68rem !important"
                          >
                            Índice
                          </span>
                          <span class="text-subtitle-1 font-weight-black">
                            {{
                              datosKpiReencauchabilidad.indice_reencauchabilidad
                            }}
                          </span>
                        </div>
                      </template>
                    </template>
                  </div>
                </div>
              </v-row>

              <GraficoBar
                Title="Índice de reencauchabilidad"
                Labelsdataset="Índice de reencauchabilidad"
                Labelscale_x="Meses"
                Labelscale_y="Reencauchabilidad"
                IdGrafico="graficoreencauchabilidad"
                :Labels="Labels"
                :DatosGrafico="datosGraficoReencauchabilidad"
                :SelectedIndex="mesSeleccionadoReencauchabilidad"
                @click-bar="seleccionarMesReencauchabilidad"
                v-if="mostrarGraficoReencauchabilidad == true"
              ></GraficoBar>
            </v-card-text>
            <v-card-actions class="dashboard-card-actions px-4 py-3">
              <v-row dense class="w-100 ma-0">
                <v-col cols="12" sm="6" class="pa-1">
                  <v-btn
                    @click="ver('reencauchabilidad')"
                    outlined
                    color="secondary"
                    small
                    block
                    class="rounded-lg text-none font-weight-bold action-dashboard-btn"
                  >
                    <v-icon left small>mdi-open-in-new</v-icon>
                    Ver Más
                  </v-btn>
                </v-col>
                <v-col cols="12" sm="6" class="pa-1">
                  <v-btn
                    @click="exportarExcelIndiceReencauchabilidad()"
                    :loading="loadingButtonReencauchabilidad"
                    color="success"
                    dark
                    small
                    block
                    class="rounded-lg text-none font-weight-bold elevation-1 action-dashboard-btn"
                  >
                    <v-icon left small>mdi-file-excel-box</v-icon>
                    Exportar Excel
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <!-- Row 3: Neumáticos por Marca & Condición -->
      <v-row class="mb-2">
        <v-col cols="12" lg="6" id="sec-neumaticos">
          <v-card
            class="dashboard-card card-top-border rounded-lg elevation-2 overflow-hidden h-100 d-flex flex-column"
          >
            <v-card-title
              class="dashboard-card-title py-3 px-4 d-flex align-center justify-space-between flex-wrap"
            >
              <div class="d-flex align-center">
                <v-icon color="secondary" class="mr-2">mdi-tag-outline</v-icon>
                <span class="text-h6 font-weight-bold text--primary"
                  >Neumáticos por Marca</span
                >
              </div>
              <v-chip
                small
                color="grey lighten-3"
                class="font-weight-bold text-caption grey--text text--darken-3 px-3"
              >
                <v-icon left x-small color="grey darken-2">mdi-counter</v-icon>
                Total: {{ totalNeumaticosMarca }}
              </v-chip>
            </v-card-title>
            <v-card-subtitle
              class="dashboard-card-subtitle px-4 pt-1 pb-2 d-flex align-center"
            >
              <v-icon x-small color="grey" class="mr-1">mdi-chart-pie</v-icon>
              <span
                >Distribución del inventario de neumáticos según fabricante
                principal</span
              >
            </v-card-subtitle>
            <v-card-text
              class="px-4 py-3 flex-grow-1 d-flex align-center justify-center"
            >
              <GraficoPie
                Title=""
                IdGrafico="graficomarcas"
                :Labels="Marcas"
                :DatosGrafico="CantidadMarcas"
                v-if="mostrarGraficos == true"
              ></GraficoPie>
            </v-card-text>
            <v-card-actions class="dashboard-card-actions px-4 py-3">
              <v-row dense class="w-100 ma-0">
                <v-col cols="12" sm="6" class="pa-1">
                  <v-btn
                    @click="ver('neumaticos')"
                    outlined
                    color="secondary"
                    small
                    block
                    class="rounded-lg text-none font-weight-bold action-dashboard-btn"
                  >
                    <v-icon left small>mdi-open-in-new</v-icon>
                    Ver Inventario
                  </v-btn>
                </v-col>
                <v-col cols="12" sm="6" class="pa-1">
                  <v-btn
                    @click="exportarExcelNeumaticosPorMarca()"
                    color="success"
                    dark
                    :loading="loadingButtonMarca"
                    small
                    block
                    class="rounded-lg text-none font-weight-bold elevation-1 action-dashboard-btn"
                  >
                    <v-icon left small>mdi-file-excel-box</v-icon>
                    Exportar Excel
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>

        <v-col cols="12" lg="6">
          <v-card
            class="dashboard-card card-top-border rounded-lg elevation-2 overflow-hidden h-100 d-flex flex-column"
          >
            <v-card-title
              class="dashboard-card-title py-3 px-4 d-flex align-center justify-space-between flex-wrap"
            >
              <div class="d-flex align-center">
                <v-icon color="secondary" class="mr-2">mdi-tire</v-icon>
                <span class="text-h6 font-weight-bold text--primary"
                  >Condición de Neumáticos</span
                >
              </div>
              <v-chip
                small
                color="grey lighten-3"
                class="font-weight-bold text-caption grey--text text--darken-3 px-3"
              >
                <v-icon left x-small color="grey darken-2">mdi-counter</v-icon>
                Total: {{ totalNeumaticosMarca }}
              </v-chip>
            </v-card-title>
            <v-card-subtitle
              class="dashboard-card-subtitle px-4 pt-1 pb-2 d-flex align-center"
            >
              <v-icon x-small color="grey" class="mr-1">mdi-chart-arc</v-icon>
              <span
                >Comparativa de unidades originales versus reencauchadas en
                flota</span
              >
            </v-card-subtitle>
            <v-card-text
              class="px-4 py-3 flex-grow-1 d-flex align-center justify-center"
            >
              <GraficoPie
                Title=""
                IdGrafico="graficocondicionneumaticos"
                :Labels="CondicionNeumaticos"
                :DatosGrafico="CantidadxCondicionNeumaticos"
                v-if="mostrarGraficos == true"
              >
              </GraficoPie>
            </v-card-text>
            <v-card-actions class="dashboard-card-actions px-4 py-3">
              <v-row dense class="w-100 ma-0">
                <v-col cols="12" sm="6" class="pa-1">
                  <v-btn
                    @click="ver('neumaticos')"
                    outlined
                    color="secondary"
                    small
                    block
                    class="rounded-lg text-none font-weight-bold action-dashboard-btn"
                  >
                    <v-icon left small>mdi-open-in-new</v-icon>
                    Ver Inventario
                  </v-btn>
                </v-col>
                <v-col cols="12" sm="6" class="pa-1">
                  <v-btn
                    @click="exportarExcelNeumaticosPorCondicion()"
                    color="success"
                    dark
                    :loading="loadingButtonCondicion"
                    small
                    block
                    class="rounded-lg text-none font-weight-bold elevation-1 action-dashboard-btn"
                  >
                    <v-icon left small>mdi-file-excel-box</v-icon>
                    Exportar Excel
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <!-- Row 4: Neumáticos por Modelo y Diseño -->
      <v-row class="mb-2">
        <v-col cols="12">
          <v-card
            class="dashboard-card card-top-border rounded-lg elevation-2 overflow-hidden"
          >
            <v-card-title
              class="dashboard-card-title py-3 px-4 d-flex align-center justify-space-between flex-wrap"
            >
              <div class="d-flex align-center">
                <v-icon color="secondary" class="mr-2"
                  >mdi-car-tire-alert</v-icon
                >
                <span class="text-h6 font-weight-bold text--primary"
                  >Neumáticos por Modelo y Diseño</span
                >
              </div>
              <v-chip
                small
                color="grey lighten-3"
                class="font-weight-bold text-caption grey--text text--darken-3 px-3"
              >
                <v-icon left x-small color="grey darken-2">mdi-counter</v-icon>
                Total: {{ totalNeumaticosMarca }}
              </v-chip>
            </v-card-title>
            <v-card-subtitle
              class="dashboard-card-subtitle px-4 pt-1 pb-2 d-flex align-center"
            >
              <v-icon x-small color="grey" class="mr-1"
                >mdi-chart-box-outline</v-icon
              >
              <span
                >Desglose de unidades según modelo comercial y patrón de diseño
                de banda</span
              >
            </v-card-subtitle>
            <v-card-text class="px-4 py-3">
              <GraficoBarDatasets
                Title="Índice de reencauche"
                Labelsdataset1="Modelos"
                Labelsdataset2="Disenios"
                Labelscale_x=""
                Labelscale_y=""
                IdGrafico="graficomodelosydisenios"
                :Background="BackgroundModelosyDisenios"
                :Border="BorderModelosyDisenios"
                :Labels="ModelosyDisenios"
                :DatosGraficoDataset="CantidadModelosyDisenios"
                :TooltipLines="TooltipModelosyDisenios"
                v-if="mostrarGraficos == true"
              ></GraficoBarDatasets>
            </v-card-text>
            <v-card-actions class="dashboard-card-actions px-4 py-3">
              <v-row dense class="w-100 ma-0">
                <v-col cols="12" sm="6" class="pa-1">
                  <v-btn
                    @click="ver('neumaticos')"
                    outlined
                    color="secondary"
                    small
                    block
                    class="rounded-lg text-none font-weight-bold action-dashboard-btn"
                  >
                    <v-icon left small>mdi-open-in-new</v-icon>
                    Ver Inventario
                  </v-btn>
                </v-col>
                <v-col cols="12" sm="6" class="pa-1">
                  <v-btn
                    @click="exportarExcelNeumaticosPorModeloyDisenio()"
                    color="success"
                    dark
                    :loading="loadingButtonModelo"
                    small
                    block
                    class="rounded-lg text-none font-weight-bold elevation-1 action-dashboard-btn"
                  >
                    <v-icon left small>mdi-file-excel-box</v-icon>
                    Exportar Excel
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <!-- Row 5: Neumáticos por Medida & Reporte Scrap -->
      <v-row class="mb-2">
        <v-col cols="12" lg="6">
          <v-card
            class="dashboard-card card-top-border rounded-lg elevation-2 overflow-hidden h-100 d-flex flex-column"
          >
            <v-card-title
              class="dashboard-card-title py-3 px-4 d-flex align-center justify-space-between flex-wrap"
            >
              <div class="d-flex align-center">
                <v-icon color="secondary" class="mr-2"
                  >mdi-arrow-expand-horizontal</v-icon
                >
                <span class="text-h6 font-weight-bold text--primary"
                  >Neumáticos por Medida</span
                >
              </div>
              <v-chip
                small
                color="grey lighten-3"
                class="font-weight-bold text-caption grey--text text--darken-3 px-3"
              >
                <v-icon left x-small color="grey darken-2">mdi-counter</v-icon>
                Total: {{ totalNeumaticosMarca }}
              </v-chip>
            </v-card-title>
            <v-card-subtitle
              class="dashboard-card-subtitle px-4 pt-1 pb-2 d-flex align-center"
            >
              <v-icon x-small color="grey" class="mr-1">mdi-ruler</v-icon>
              <span
                >Clasificación dimensional de neumáticos instalados en flota
                activa</span
              >
            </v-card-subtitle>
            <v-card-text class="px-4 py-3 flex-grow-1">
              <GraficoBar
                Title=""
                Labelsdataset="Neumáticos"
                Labelscale_x="Medidas"
                Labelscale_y="Cantidad"
                IdGrafico="graficomedidas"
                :Labels="Medidas"
                :DatosGrafico="CantidadMedidas"
                :TooltipLines="TooltipMedidas"
                :Tamanio="9"
                v-if="mostrarGraficos == true"
              ></GraficoBar>
            </v-card-text>
            <v-card-actions class="dashboard-card-actions px-4 py-3">
              <v-row dense class="w-100 ma-0">
                <v-col cols="12" sm="6" class="pa-1">
                  <v-btn
                    @click="ver('neumaticos')"
                    outlined
                    color="secondary"
                    small
                    block
                    class="rounded-lg text-none font-weight-bold action-dashboard-btn"
                  >
                    <v-icon left small>mdi-open-in-new</v-icon>
                    Ver Inventario
                  </v-btn>
                </v-col>
                <v-col cols="12" sm="6" class="pa-1">
                  <v-btn
                    @click="exportarExcelNeumaticosPorMedida()"
                    color="success"
                    dark
                    :loading="loadingButtonMedida"
                    small
                    block
                    class="rounded-lg text-none font-weight-bold elevation-1 action-dashboard-btn"
                  >
                    <v-icon left small>mdi-file-excel-box</v-icon>
                    Exportar Excel
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>

        <v-col cols="12" lg="6">
          <v-card
            class="dashboard-card card-top-border rounded-lg elevation-2 overflow-hidden h-100 d-flex flex-column"
          >
            <v-card-title
              class="dashboard-card-title py-3 px-4 d-flex align-center justify-space-between flex-wrap"
            >
              <div class="d-flex align-center">
                <v-icon color="secondary" class="mr-2"
                  >mdi-delete-empty-outline</v-icon
                >
                <span class="text-h6 font-weight-bold text--primary">{{
                  cardTitleScrap
                }}</span>
              </div>
              <div class="d-flex align-center">
                <v-btn-toggle
                  v-model="scrapViewMode"
                  mandatory
                  dense
                  color="secondary"
                  class="rounded-pill overflow-hidden elevation-1 mr-2 custom-toggle"
                  style="height: 28px"
                >
                  <v-btn
                    value="anual"
                    small
                    class="text-none font-weight-bold px-3"
                    >Anual</v-btn
                  >
                  <v-btn
                    value="motivo"
                    small
                    class="text-none font-weight-bold px-3"
                    >Por Motivo</v-btn
                  >
                </v-btn-toggle>
                <v-chip
                  small
                  color="grey lighten-3"
                  class="font-weight-bold text-caption grey--text text--darken-3 px-3"
                >
                  <v-icon left x-small color="grey darken-2"
                    >mdi-counter</v-icon
                  >
                  Total: {{ totalNeumaticosScrap }}
                </v-chip>
              </div>
            </v-card-title>
            <v-card-subtitle
              class="dashboard-card-subtitle px-4 pt-1 pb-2 d-flex align-center flex-wrap"
            >
              <div class="d-flex align-center">
                <v-icon x-small color="grey" class="mr-1">mdi-history</v-icon>
                <span>{{ cardSubtitleScrap }}</span>
              </div>
              <v-spacer></v-spacer>
              <div style="width: 100px" v-if="scrapViewMode === 'motivo'">
                <v-select
                  v-model="scrapSelectedYear"
                  :items="scrapYearsList"
                  dense
                  hide-details
                  outlined
                  background-color="grey lighten-4"
                  color="secondary"
                  class="caption my-0 py-0 custom-mini-select rounded-lg"
                ></v-select>
              </div>
            </v-card-subtitle>
            <v-card-text class="px-4 py-3 flex-grow-1">
              <GraficoBar
                Title=""
                Labelsdataset="Neumáticos"
                :Labelscale_x="scrapViewMode === 'motivo' ? 'Cantidad' : 'Años'"
                :Labelscale_y="
                  scrapViewMode === 'motivo' ? 'Motivos' : 'Cantidad'
                "
                :IdGrafico="
                  'graficoscrap_' + scrapViewMode + '_' + scrapSelectedYear
                "
                :key="scrapViewMode + '_' + scrapSelectedYear"
                :Labels="chartLabels"
                :DatosGrafico="chartData"
                :TooltipLines="chartTooltips"
                :Tamanio="9"
                :Orientacion="scrapViewMode === 'motivo' ? 'y' : 'x'"
                v-if="mostrarGraficos == true"
              >
              </GraficoBar>
            </v-card-text>
            <v-card-actions class="dashboard-card-actions px-4 py-3">
              <v-row dense class="w-100 ma-0">
                <v-col cols="12" sm="6" class="pa-1">
                  <v-btn
                    @click="ver('neumaticos')"
                    outlined
                    color="secondary"
                    small
                    block
                    class="rounded-lg text-none font-weight-bold action-dashboard-btn"
                  >
                    <v-icon left small>mdi-open-in-new</v-icon>
                    Ver Inventario
                  </v-btn>
                </v-col>
                <v-col cols="12" sm="6" class="pa-1">
                  <v-btn
                    @click="exportarExcelNeumaticosEnScrapPorAnio()"
                    color="success"
                    dark
                    :loading="loadingButtonScrap"
                    small
                    block
                    class="rounded-lg text-none font-weight-bold elevation-1 action-dashboard-btn"
                  >
                    <v-icon left small>mdi-file-excel-box</v-icon>
                    Exportar Excel
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <!-- Row 6: Neumáticos por Estado -->
      <v-row class="mb-2">
        <v-col cols="12">
          <v-card
            class="dashboard-card card-top-border rounded-lg elevation-2 overflow-hidden"
          >
            <v-card-title
              class="dashboard-card-title py-3 px-4 d-flex align-center justify-space-between flex-wrap"
            >
              <div class="d-flex align-center">
                <v-icon color="secondary" class="mr-2">mdi-list-status</v-icon>
                <span class="text-h6 font-weight-bold text--primary"
                  >Neumáticos por Estado</span
                >
              </div>
              <v-chip
                small
                color="grey lighten-3"
                class="font-weight-bold text-caption grey--text text--darken-3 px-3"
              >
                <v-icon left x-small color="grey darken-2">mdi-counter</v-icon>
                Total: {{ totalNeumaticosMarca }}
              </v-chip>
            </v-card-title>
            <v-card-subtitle
              class="dashboard-card-subtitle px-4 pt-1 pb-2 d-flex align-center"
            >
              <v-icon x-small color="grey" class="mr-1"
                >mdi-progress-check</v-icon
              >
              <span
                >Distribución del parque según estado físico operativo (Montado,
                Reparación, Scrap, etc.)</span
              >
            </v-card-subtitle>
            <v-card-text class="px-4 py-3 d-flex align-center justify-center">
              <GraficoPie
                Title=""
                IdGrafico="graficoestados"
                :Labels="Estados"
                :DatosGrafico="CantidadEstados"
                v-if="mostrarGraficos == true"
              ></GraficoPie>
            </v-card-text>
            <v-card-actions class="dashboard-card-actions px-4 py-3">
              <v-row dense class="w-100 ma-0">
                <v-col cols="12" sm="6" class="pa-1">
                  <v-btn
                    @click="ver('neumaticos')"
                    outlined
                    color="secondary"
                    small
                    block
                    class="rounded-lg text-none font-weight-bold action-dashboard-btn"
                  >
                    <v-icon left small>mdi-open-in-new</v-icon>
                    Ver Inventario
                  </v-btn>
                </v-col>
                <v-col cols="12" sm="6" class="pa-1">
                  <v-btn
                    @click="exportarExcelNeumaticosPorEstado()"
                    :loading="loadingButtonEstado"
                    color="success"
                    dark
                    small
                    block
                    class="rounded-lg text-none font-weight-bold elevation-1 action-dashboard-btn"
                  >
                    <v-icon left small>mdi-file-excel-box</v-icon>
                    Exportar Excel
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-col>

    <!-- modal detalles costo por kilometro-->
    <v-dialog v-model="dialog" max-width="1000px">
      <v-card class="rounded-lg overflow-hidden elevation-4">
        <v-toolbar height="52" color="secondary" dark flat class="px-3">
          <v-icon left>mdi-table-large</v-icon>
          <span class="text-subtitle-1 font-weight-medium"
            >Detalles del Indicador &mdash; Año {{ annio }}</span
          >
          <v-spacer></v-spacer>
          <v-btn icon dark @click="cerrarDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-4">
          <div class="table-responsive-wrapper">
            <table class="matriz-table" id="table">
              <thead>
                <tr class="header-dark">
                  <th class="table-border texto-cen pa-2" style="width: 8%">
                    Marca
                  </th>
                  <th class="table-border texto-cen pa-2" style="width: 8%">
                    Modelo
                  </th>
                  <th class="table-border texto-cen pa-2" style="width: 8%">
                    Medida
                  </th>
                  <th class="table-border texto-cen pa-2" style="width: 8%">
                    Lote
                  </th>
                  <th class="table-border texto-cen pa-2" style="width: 14%">
                    Suma Precio
                  </th>
                  <th class="table-border texto-cen pa-2" style="width: 14%">
                    Promedio Precio
                  </th>
                  <th class="table-border texto-cen pa-2" style="width: 14%">
                    Suma KM Recorrido
                  </th>
                  <th class="table-border texto-cen pa-2" style="width: 14%">
                    KM Rendimiento
                  </th>
                  <th class="table-border texto-cen pa-2" style="width: 10%">
                    Indicador
                  </th>
                  <th class="table-border texto-cen pa-2" style="width: 10%">
                    Mes
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in detallesCosto"
                  :key="index"
                  class="data-row"
                >
                  <td class="table-border texto-cen pa-2 font-weight-medium">
                    {{ item.marca }}
                  </td>
                  <td class="table-border texto-cen pa-2">{{ item.modelo }}</td>
                  <td class="table-border texto-cen pa-2 text-caption">
                    {{ item.medida }}
                  </td>
                  <td class="table-border texto-cen pa-2 font-mono">
                    {{ item.total_lote }}
                  </td>
                  <td
                    class="table-border texto-cen pa-2 font-mono primary--text font-weight-bold"
                  >
                    $
                    {{
                      Number(item.suma_precio || 0).toLocaleString("es-PE", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    }}
                  </td>
                  <td class="table-border texto-cen pa-2 font-mono">
                    $
                    {{
                      Number(item.promedio_precio || 0).toLocaleString(
                        "es-PE",
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 },
                      )
                    }}
                  </td>
                  <td class="table-border texto-cen pa-2 font-mono">
                    {{
                      Number(item.suma_km_recorrido || 0).toLocaleString(
                        "es-PE",
                      )
                    }}
                  </td>
                  <td class="table-border texto-cen pa-2 font-mono">
                    {{
                      Number(item.promedio_km_recorrido || 0).toLocaleString(
                        "es-PE",
                      )
                    }}
                  </td>
                  <td
                    class="table-border texto-cen pa-2 font-mono font-weight-bold"
                  >
                    {{ item.indicador }}
                  </td>
                  <td class="table-border texto-cen pa-2 font-weight-medium">
                    {{ mes(item.fecha_mes) }}
                  </td>
                </tr>
                <tr v-if="detallesCosto.length == 0">
                  <td
                    colspan="10"
                    class="table-border texto-cen pa-6 text--secondary"
                  >
                    <v-icon
                      size="32"
                      color="grey lighten-1"
                      class="d-block mx-auto mb-2"
                      >mdi-database-off-outline</v-icon
                    >
                    <span>No se encontraron datos registrados</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-card-text>
        <v-card-actions class="dashboard-card-actions px-4 py-3">
          <v-spacer></v-spacer>
          <v-btn
            @click="cerrarDialog()"
            outlined
            color="secondary"
            small
            class="rounded-lg text-none px-4 font-weight-bold"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import plugin from "@/components/Plugin.vue";
import { mapState, mapActions } from "vuex";
import IndicadorCosto from "../components/indicador/tabla.vue";
import GraficoBar from "../components/GraficoBar.vue";
import GraficoPie from "../components/GraficoPie.vue";
import GraficoBarDatasets from "../components/GraficoBarDatasets.vue";
import global from "../global";
import { axios2 as axios } from "@/interceptor/useApi";
import moment from "moment";

export default {
  name: "Home",
  components: {
    plugin,
    IndicadorCosto,
    GraficoBar,
    GraficoBarDatasets,
    GraficoPie,
  },
  data() {
    return {
      annio: "",
      meses: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ],
      detallesCosto: [],
      mesSeleccionadoCosto: null,
      celdaSeleccionadaCosto: null,
      mesSeleccionadoReencauche: null,
      mesSeleccionadoReencauchabilidad: null,
      datosGraficoReencauche: [],
      datosGraficoReencauchabilidad: [],
      mostrarGraficoReencauche: false,
      mostrarGraficoReencauchabilidad: false,
      mostrarGraficoMarcas: false,
      mostrarGraficos: false,
      totalNeumaticosMarca: 0,
      loadingButtonCosto: false,
      scrapViewMode: "anual",
      scrapSelectedYear: "",
      loadingButtonReencauche: false,
      loadingButtonReencauchabilidad: false,
      loadingButtonMarca: false,
      loadingButtonCondicion: false,
      loadingButtonModelo: false,
      loadingButtonEstado: false,
      loadingButtonMedida: false,
      loadingButtonScrap: false,
      loadingVerDetalle: false,
      dialog: false,
    };
  },
  computed: {
    ...mapState("indicadores", [
      "MesesCostoPorKilometro",
      "CostoPorKilometro",
      "IndicesReencauchePorMes",
      "IndicesReencauchabilidadPorMes",
      "DatosTotalesAnualReencauche",
      "DatosTotalesMensualReencauche",
      "DatosTotalesAnualReencauchabilidad",
      "DatosTotalesMensualReencauchabilidad",
      "DatosTotalesAnualCosto",
      "DatosTotalesMensualCosto",
    ]),

    datosKpiCosto() {
      if (this.celdaSeleccionadaCosto && this.celdaSeleccionadaCosto.item) {
        const item = this.celdaSeleccionadaCosto.item;
        const mes = this.celdaSeleccionadaCosto.mes;
        let precio = null;
        let rendimiento = null;
        let costo = null;

        if (mes === "anual" || mes === null || mes === undefined) {
          precio = item.precio_anual;
          rendimiento = item.rendimiento_anual;
          costo = item.indicador_anual;
        } else {
          precio =
            item["precio_mes_" + mes] !== undefined
              ? item["precio_mes_" + mes]
              : item["precio_promedio"];
          rendimiento =
            item["rendimiento_mes_" + mes] !== undefined
              ? item["rendimiento_mes_" + mes]
              : item["rendimiento_promedio"];
          costo =
            item["indicador_mes_" + mes] !== undefined
              ? item["indicador_mes_" + mes]
              : item["indicador"];
        }

        return {
          precio: parseFloat(precio || 0),
          rendimiento: parseFloat(rendimiento || 0),
          costo: parseFloat(costo || 0),
          nombreIndicador:
            this.celdaSeleccionadaCosto.nombreIndicador ||
            item.nombre_indicador ||
            "",
        };
      }

      if (
        this.mesSeleccionadoCosto !== null &&
        this.mesSeleccionadoCosto !== undefined
      ) {
        const numMes = parseInt(this.mesSeleccionadoCosto);
        const mesObj = this.DatosTotalesMensualCosto.find(
          (item) => item.mes === numMes,
        );
        if (mesObj) {
          return mesObj;
        }
      }
      return this.DatosTotalesAnualCosto || {};
    },

    unidadMedidaTexto() {
      const nombre =
        this.datosKpiCosto && this.datosKpiCosto.nombreIndicador
          ? String(this.datosKpiCosto.nombreIndicador).toLowerCase()
          : "";

      if (nombre.includes("hora")) {
        return {
          label: "(hr)",
          result: "/ hr",
        };
      } else if (
        nombre.includes("kilómetro") ||
        nombre.includes("kilometro") ||
        nombre.includes("km")
      ) {
        return {
          label: "(km)",
          result: "/ km",
        };
      }

      return {
        label: "(km / hr)",
        result: "/ (km/hr)",
      };
    },

    datosKpiReencauche() {
      if (
        this.mesSeleccionadoReencauche !== null &&
        this.mesSeleccionadoReencauche !== undefined
      ) {
        const mesObj = this.DatosTotalesMensualReencauche.find(
          (item) => item.mes === this.mesSeleccionadoReencauche + 1,
        );
        if (mesObj) {
          return mesObj;
        }
      }
      return this.DatosTotalesAnualReencauche || {};
    },

    datosKpiReencauchabilidad() {
      if (
        this.mesSeleccionadoReencauchabilidad !== null &&
        this.mesSeleccionadoReencauchabilidad !== undefined
      ) {
        const mesObj = this.DatosTotalesMensualReencauchabilidad.find(
          (item) => item.mes === this.mesSeleccionadoReencauchabilidad + 1,
        );
        if (mesObj) {
          return mesObj;
        }
      }
      return this.DatosTotalesAnualReencauchabilidad || {};
    },

    ...mapState("home", [
      "Marcas",
      "CantidadMarcas",
      "CondicionNeumaticos",
      "CantidadxCondicionNeumaticos",
      "Estados",
      "CantidadEstados",
      "ModelosyDisenios",
      "CantidadModelosyDisenios",
      "TooltipModelosyDisenios",
      "BackgroundModelosyDisenios",
      "BorderModelosyDisenios",
      "Medidas",
      "CantidadMedidas",
      "TooltipMedidas",
      "Anios",
      "CantidadNeumaticosScrap",
      "scrap_por_anio",
      "scrap_por_motivo_por_anio",
    ]),

    scrapYearsList() {
      return this.scrap_por_anio.map((x) => x.anio);
    },

    chartLabels() {
      if (this.scrapViewMode === "anual") {
        return this.scrap_por_anio.map((x) => x.anio);
      } else if (this.scrapViewMode === "motivo") {
        const yearData =
          this.scrap_por_motivo_por_anio[this.scrapSelectedYear] || [];
        return yearData.map((x) => x.descripcion);
      }
      return [];
    },

    chartData() {
      if (this.scrapViewMode === "anual") {
        return this.scrap_por_anio.map((x) => x.cantidad);
      } else if (this.scrapViewMode === "motivo") {
        const yearData =
          this.scrap_por_motivo_por_anio[this.scrapSelectedYear] || [];
        return yearData.map((x) => x.cantidad);
      }
      return [];
    },

    totalNeumaticosScrap() {
      return this.chartData.reduce((sum, val) => sum + parseInt(val || 0), 0);
    },

    chartTooltips() {
      if (this.scrapViewMode === "anual") {
        return this.scrap_por_anio.map(() => null);
      } else if (this.scrapViewMode === "motivo") {
        const yearData =
          this.scrap_por_motivo_por_anio[this.scrapSelectedYear] || [];
        return yearData.map((x) => x.tooltipLines || null);
      }
      return [];
    },

    cardTitleScrap() {
      if (this.scrapViewMode === "anual") {
        return "Reporte Scrap por Año";
      } else {
        return `Scrap por Motivo (${this.scrapSelectedYear})`;
      }
    },

    cardSubtitleScrap() {
      if (this.scrapViewMode === "anual") {
        return "Últimos 5 años";
      } else {
        return "Agrupado por motivo de retiro";
      }
    },
  },
  watch: {
    scrapViewMode(val) {
      if (val === "motivo") {
        this.scrapSelectedYear = parseInt(this.annio);
      }
    },
  },
  methods: {
    ...mapActions("indicadores", [
      "reporteCostoPorKilometro",
      "reporteIndiceReencauche",
      "reporteIndiceReencauchabilidad",
    ]),

    ...mapActions("home", ["datosGraficos"]),

    seleccionarMesReencauche(index) {
      if (index === null || index === undefined) {
        this.mesSeleccionadoReencauche = null;
      } else if (this.mesSeleccionadoReencauche === index) {
        this.mesSeleccionadoReencauche = null;
      } else {
        this.mesSeleccionadoReencauche = index;
      }
    },

    seleccionarMesReencauchabilidad(index) {
      if (index === null || index === undefined) {
        this.mesSeleccionadoReencauchabilidad = null;
      } else if (this.mesSeleccionadoReencauchabilidad === index) {
        this.mesSeleccionadoReencauchabilidad = null;
      } else {
        this.mesSeleccionadoReencauchabilidad = index;
      }
    },

    mes: function (numeromes) {
      return this.meses[parseInt(numeromes) - 1];
    },

    ver(valor) {
      if (valor == "costo") {
      }
      if (valor == "reencauche") {
        this.$router.push({
          path: "/indicadorreencauche",
          query: { fromDashboard: true },
        });
      }

      if (valor == "reencauchabilidad") {
        this.$router.push({
          path: "/indicadorreencauchabilidad",
          query: { fromDashboard: true },
        });
      }

      if (valor == "neumaticos") {
        this.$router.push({
          path: "/neumaticos",
          query: { fromDashboard: true },
        });
      }
    },

    async verDetalles() {
      this.loadingVerDetalle = true;
      try {
        const data = {
          id_cliente: localStorage.getItem("idcliente"),
          year: this.annio,
        };
        const url = "reporte/detalles_costo_por_kilometro";
        await axios
          .post(url, data)
          .then((response) => {
            this.detallesCosto = response.data.success.detalles;
            this.loadingVerDetalle = false;
            this.dialog = true;
          })
          .catch((error) => {
            console.error("error!", error);
            this.errorMessage = error.response.data;
          });
      } catch (error) {
        console.log(error);
      }
    },

    exportarExcelCostoxKilometro() {
      this.loadingButtonCosto = true;
      const url =
        global.ruta_api +
        "excel/reporteindicadorcostokmhr?" +
        global._json_to_query_string({
          id_cliente: localStorage.getItem("idcliente"),
          id_usuario: localStorage.getItem("id"),
          year: this.annio,
          marca: null,
          unidadmedida: null,
        });
      this.exportarExcel(url).then((r) => {
        this.loadingButtonCosto = false;
      });
    },

    exportarExcelIndiceReencauche() {
      this.loadingButtonReencauche = true;
      const url =
        global.ruta_api +
        "excel/reporteindicereencauche?" +
        global._json_to_query_string({
          id_cliente: localStorage.getItem("idcliente"),
          id_usuario: localStorage.getItem("id"),
          year: this.annio,
        });
      this.exportarExcel(url).then((r) => {
        this.loadingButtonReencauche = false;
      });
    },

    exportarExcelIndiceReencauchabilidad() {
      this.loadingButtonReencauchabilidad = true;
      const url =
        global.ruta_api +
        "excel/reporteindicereencauchabilidad?" +
        global._json_to_query_string({
          id_cliente: localStorage.getItem("idcliente"),
          id_usuario: localStorage.getItem("id"),
          year: this.annio,
        });

      this.exportarExcel(url).then((r) => {
        this.loadingButtonReencauchabilidad = false;
      });
    },

    exportarExcelNeumaticosPorMarca() {
      this.loadingButtonMarca = true;
      const url =
        global.ruta_api +
        "excel/reporteneumaticospormarca?" +
        global._json_to_query_string({
          id_cliente: localStorage.getItem("idcliente"),
          id_usuario: localStorage.getItem("id"),
        });
      this.exportarExcel(url).then((r) => {
        this.loadingButtonMarca = false;
      });
    },

    exportarExcelNeumaticosPorCondicion() {
      this.loadingButtonCondicion = true;
      const url =
        global.ruta_api +
        "excel/reporteneumaticosporcondicion?" +
        global._json_to_query_string({
          id_cliente: localStorage.getItem("idcliente"),
          id_usuario: localStorage.getItem("id"),
        });
      this.exportarExcel(url).then((r) => {
        this.loadingButtonCondicion = false;
      });
    },

    exportarExcelNeumaticosPorModeloyDisenio() {
      this.loadingButtonModelo = true;
      const url =
        global.ruta_api +
        "excel/reporteneumaticospormodeloydisenio?" +
        global._json_to_query_string({
          id_cliente: localStorage.getItem("idcliente"),
          id_usuario: localStorage.getItem("id"),
        });
      this.exportarExcel(url).then((r) => {
        this.loadingButtonModelo = false;
      });
    },

    exportarExcelNeumaticosPorEstado() {
      this.loadingButtonEstado = true;
      const url =
        global.ruta_api +
        "excel/reporteneumaticosporestado?" +
        global._json_to_query_string({
          id_cliente: localStorage.getItem("idcliente"),
          id_usuario: localStorage.getItem("id"),
        });
      this.exportarExcel(url).then((r) => {
        this.loadingButtonEstado = false;
      });
    },

    exportarExcelNeumaticosPorMedida() {
      this.loadingButtonMedida = true;
      const url =
        global.ruta_api +
        "excel/reporteneumaticospormedida?" +
        global._json_to_query_string({
          id_cliente: localStorage.getItem("idcliente"),
          id_usuario: localStorage.getItem("id"),
        });
      this.exportarExcel(url).then((r) => {
        this.loadingButtonMedida = false;
      });
    },

    exportarExcelNeumaticosEnScrapPorAnio() {
      this.loadingButtonScrap = true;
      const url =
        global.ruta_api +
        "excel/reporteneumaticosenscrapporanio?" +
        global._json_to_query_string({
          id_cliente: localStorage.getItem("idcliente"),
          id_usuario: localStorage.getItem("id"),
          tipo_vista: this.scrapViewMode,
          year: this.scrapSelectedYear,
        });
      this.exportarExcel(url).then((r) => {
        this.loadingButtonScrap = false;
      });
    },

    async exportarExcel(url) {
      try {
        await axios({
          url: url,
          method: "GET",
          responseType: "blob",
        })
          .then(async (response) => {
            var nombre_archivo = response.headers["nombre-archivo"];
            if (response.data.type == "text/html") {
              // no es excel, probablemente es json con un mensaje de error
              const res = JSON.parse(await response.data.text());
              if (!res.exito) {
                alert(res.mensaje || "Sucedió un error, intentelo nuevamente");
              }
            } else {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", nombre_archivo);
              document.body.appendChild(link);
              link.click();
            }
          })
          .catch((error) => {
            this.errorMessage = error.response.data;
            console.error("error!", error);
          });
      } catch (error) {
        console.log(error);
      }
    },

    cerrarDialog: function () {
      this.dialog = false;
    },

    async cargarDatos() {
      let fecha = moment(new Date(), "YYYY-MM-DD"); //2021-05-20 //YYYY-MM-DD
      this.annio = fecha.format("YYYY");
      let datos = {
        anio: this.annio,
        marca: null,
        unidadmedida: null,
      };

      this.Labels = this.meses;
      await this.reporteCostoPorKilometro(datos);
      await this.reporteIndiceReencauche(this.annio);
      this.IndicesReencauchePorMes.forEach((element) => {
        this.datosGraficoReencauche.push((element * 100).toFixed(2));
      });
      this.mostrarGraficoReencauche = true;

      await this.reporteIndiceReencauchabilidad(this.annio);
      this.datosGraficoReencauchabilidad = [];
      this.IndicesReencauchabilidadPorMes.forEach((element) => {
        this.datosGraficoReencauchabilidad.push(element);
      });
      this.mostrarGraficoReencauchabilidad = true;

      await this.datosGraficos();
      this.scrapSelectedYear = parseInt(this.annio);
      this.CantidadMarcas.forEach((element) => {
        this.totalNeumaticosMarca += parseInt(element);
      });

      this.mostrarGraficos = true;

      if (this.$route.hash) {
        this.$nextTick(() => {
          setTimeout(() => {
            const el = document.querySelector(this.$route.hash);
            if (el) {
              el.scrollIntoView({ behavior: "smooth" });
            }
          }, 400);
        });
      }
    },
  },
  mounted() {
    this.cargarDatos();
  },
};
</script>

<style scoped>
.dashboard-card {
  border: 1px solid #e2e8f0 !important;
  background-color: #ffffff !important;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.dashboard-card:hover {
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.07) !important;
}

.card-top-border {
  border-top: 3px solid #424242 !important;
}

.dashboard-card-title {
  border-bottom: 1px solid #f1f5f9;
  background-color: #ffffff;
}

.dashboard-card-subtitle {
  color: #64748b !important;
  font-size: 0.8rem !important;
  line-height: 1.35;
}

.dashboard-card-actions {
  background-color: #f8fafc;
  border-top: 1px solid #f1f5f9;
}

.action-dashboard-btn {
  letter-spacing: 0.3px;
  height: 36px !important;
  transition: transform 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
}

.action-dashboard-btn:hover {
  transform: translateY(-1px);
}

.kpi-formula-container {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}

.border-subtle {
  border: 1px solid #e2e8f0;
}

.border-bottom-fraction {
  border-bottom: 2px solid #cbd5e1;
}

.kpi-result-chip {
  background: linear-gradient(135deg, #1e293b, #0f172a);
  color: #ffffff;
  min-width: 120px;
  text-align: center;
}

.font-mono {
  font-family: monospace, "Courier New", Courier !important;
  letter-spacing: 0.2px;
}

.table-responsive-wrapper {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-responsive-wrapper::-webkit-scrollbar {
  height: 6px;
}

.table-responsive-wrapper::-webkit-scrollbar-track {
  background: #f1f5f9;
}

.table-responsive-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.table-responsive-wrapper::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.matriz-table {
  width: 100%;
  border-collapse: collapse;
}

.table-border {
  border: 1px solid #e2e8f0;
}

.header-dark th {
  background-color: #424242 !important;
  color: #ffffff !important;
  font-size: 0.78rem !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px;
  padding: 8px 6px !important;
}

.data-row:hover td {
  background-color: #f8fafc;
}

.texto-cen {
  text-align: center;
}

.custom-mini-select :deep(.v-input__slot) {
  min-height: 24px !important;
  height: 24px !important;
  padding: 0 6px !important;
}

.custom-mini-select :deep(.v-input__append-inner) {
  margin-top: 0px !important;
  padding-left: 0px !important;
}

.custom-mini-select :deep(.v-input__icon) {
  height: 24px !important;
  width: 18px !important;
  min-width: 18px !important;
}

.custom-mini-select :deep(.v-select__selection) {
  font-size: 11px !important;
  margin: 2px 0 !important;
}

.custom-toggle :deep(.v-btn) {
  font-size: 0.75rem !important;
}
</style>
